<template>
	<div class="slim-mainpanel">
		<div class="container">
			<div class="slim-pageheader">
				<ol class="breadcrumb slim-breadcrumb">
					<li class="breadcrumb-item"><a href="#">Operacional</a></li>
					<li class="breadcrumb-item"><a href="#">Importação</a></li>
					<li class="breadcrumb-item"><a href="#">Relatórios</a></li>
					<li class="breadcrumb-item active" aria-current="page">
						DUIMP Registradas
					</li>
				</ol>
				<h6 class="slim-pagetitle">DUIMP Registradas</h6>
			</div>

			<div class="bd bd-1 bd-b-0">
				<div class="bd-t bd-5 bd-gray-800 pd-x-10 bg-white d-flex justify-content-between align-items-center pd-b-5 pd-t-5">
					<ul class="nav gap1">
						<li class="mg-t-5">
							<div class="dropdown dropdown-demo">
								<a href="#" class="dd-link" data-toggle="dropdown">
									<div v-if=" filters.start !== '' && filters.end !== ''">
										<span class="mg-l-0 pd-l-0"> 
											<i class="fa fa-calendar tx-info mg-r-5"></i>Período:
											<span class="pd-x-5 badge badge-info mg-b-0 mg-r-2-force tx-thin-force">
												de {{ filters.start | moment("DD/MM/YYYY") }}
												até {{ filters.end | moment("DD/MM/YYYY") }}
											</span>
											<i class="fa fa-angle-down mg-l-5"></i>
										</span>
									</div>
									<div v-else>
										<span><i class="fa fa-calendar mg-r-5"></i> Período:</span>
										<i class="fa fa-angle-down mg-l-5"></i>
									</div>
								</a>

								<div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
									<h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-10">
										Data do Registro da DUIMP
									</h6>
									<p class="tx-gray-600 mg-b-10">
										Selecione a data inicial e final
									</p>
									<div class="form-layout form-layout-2">
										<div class="row no-gutters">
											<div class="col-md-6">
												<div class="form-group">
													<label class="form-control-label">
														Data Inicial <span class="tx-danger">*</span>
													</label>
													<date-picker
														lang="pt-br"
														v-model="filters.start"
														name="toPickedDate"
														format="DD/MM/YYYY"
														placeholder="Data Inicial"
													></date-picker>
												</div>
											</div>
											<div class="col-md-6 mg-t--1 mg-md-t-0">
												<div class="form-group mg-md-l--1">
													<label class="form-control-label">
														Data Final <span class="tx-danger">*</span>
													</label>
													<date-picker
														lang="pt-br"
														v-model="filters.end"
														name="toPickedDate"
														format="DD/MM/YYYY"
														placeholder="Data Final"
													></date-picker>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</li>
						<li class="mg-t-5">
							<div class="dropdown dropdown-demo mg-l-10" data-pesistent>
								<a href="#" class="dd-link tx-light" data-toggle="dropdown">
									<div v-if="filters.customer">
										<span class="mg-l-0 pd-l-0">
											<i class="fa fa-building tx-danger mg-r-5"></i>Clientes:
											<span class="pd-x-5 badge badge-danger mg-b-0 mg-r-2-force tx-thin-force"> {{ filters?.customer?.name }}</span>
											<i class="fa fa-angle-down mg-l-5"></i>
										</span>
									</div>

									<div v-else>
										<span><i class="fa fa-building tx-medium mg-r-5"></i> Clientes</span>
										<i class="fa fa-angle-down mg-l-5"></i>
									</div>
								</a>
								<div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
									<h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-10">
										Clientes
									</h6>
									<p class="tx-gray-600 mg-b-10">
										Selecione um cliente
									</p>
									<div class="form-layout form-layout-2">
										<div class="row no-gutters">
											<div class="col-md-12">
												<div class="form-group">
													<label class="form-control-label"> Clientes </label>
													<v-select
														v-model="filters.customer"
														label="name"
														:options="listOfCustomers"
														name="customers"
													>
														<template slot="option" slot-scope="option">
															{{ option.name }}
														</template>
													</v-select>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							</li>
					</ul>
					<ul class="nav nav-white-800 flex-column flex-md-row tx-white tx-15">
						<li class="mg-l-10">
							<div class="btn-group gap1" role="group" aria-label="Ações">
								<button type="button" class="btn btn-primary pd-x-20 " @click.prevent="generateReport('tela')"> <i class="fa fa-file-code-o mg-r-5"></i> GERAR </button>
								<button type="button" class="btn btn-teal pd-x-20flex ai-c" @click.prevent="generateReport('excel')"> <i class="fa fa-file-excel-o mg-r-5"></i>  EXCEL </button>
							</div>
						</li>
					</ul>
				</div>

				<div class="section-wrapper mg-t-0 pd-0 bd-1 bd-l-0 bd-r-0 bd-b-1">
					<div class="pd-10 mg-10">
						<div class="flex ai-c jc-sb fgap2">
							<div> 
								<label class="section-title mg-t-10 tx-16">Resultado da Consulta</label>
								<p class="mg-b-0">Foram encontrados {{ somaTotalDUIMPs }} registros de acordo com o filtro acima.</p>
							</div>
						</div>
						<hr/>

						<template v-if="duimps.length > 0">
							<table class="table table-striped mg-b-20 bd bd-1" v-for="duimp in duimps" :key="duimp._id">
								<thead>
									<tr>
										<th class="tx-center wd-125">Número DUIMP</th>
										<th class="tx-center wd-125">Versão</th>
										<th>Importador / Adquirente</th>
										<th class="tx-center">Itens</th>
										<th class="tx-center">Registro</th>
										<th class="tx-center">Desembaraço</th>
									</tr>
							</thead>
								<tbody>
									<tr :key="duimp._id">
										<td scope="row" class="tx-center wd-125">{{duimp.number | formatDuimpNumber}}</td>
										<td class="tx-center wd-125"><small>{{duimp.version || "N/I"}}</small></td>
										<td>
											<strong style="text-transform: uppercase">{{duimp.process?.account?.federalID || "N/I"}}</strong>
											<br />
											<small style="text-transform: uppercase">{{duimp.process?.account?.completeName || "N/I"}}</small>
											<br />
											<strong style="text-transform: uppercase">{{duimp.process?.customer?.federalID || "N/I"}}</strong>
											<br />
											<small style="text-transform: uppercase">{{duimp.process?.customer?.completeName || "N/I"}}</small>
										</td>
										<td class="tx-center">{{duimp.items.length || 0}}</td>
										<td class="tx-center">{{duimp.process?.duimpRegistryDate | moment("DD/MM/YYYY") }}</td>
										<td class="tx-center">{{duimp.process?.duimpResourcefulnessDate | moment("DD/MM/YYYY") }}</td>
									</tr>
									<tr :key="duimp.number+'-itens'">
										<td colspan="12" class="pd-0 pd-t-0 pd-b-0">
											<label class="section-title">Itens da DUIMP: {{duimp.number | formatDuimpNumber}}</label>

											<table class="table bg-white bd bd-1">
												<tr>
													<th class="tx-center"></th>
													<th class="tx-center">Incoterm</th>
													<th class="tx-right">Frete</th>
													<th class="tx-right">Seguro</th>
													<th class="tx-right">II</th>
													<th class="tx-right">IPI</th>
													<th class="tx-right">PIS/PASEP</th>
													<th class="tx-right">COFINS</th>
													<th class="tx-right">SISCOMEX</th>
												</tr>
											
												<tr v-for="item in duimp.items" :key="duimp.number+item.index" class="bg-white">
													<td class="tx-center">{{item.index}}</td>
													<td class="tx-center">{{item.sellingConditionIncotermCode}}</td>
													<td class="tx-right">{{item.sellingConditionFreightValueBrl | numeralFormat('0,0.00')}} </td>
													<td class="tx-right">{{item.sellingConditionInsuranceValueBrl | numeralFormat('0,0.00')}} </td>
													<td class="tx-right">{{item.taxesValueIi | numeralFormat('0,0.00')}} </td>
													<td class="tx-right">{{item.taxesValueIpi | numeralFormat('0,0.00')}} </td>
													<td class="tx-right">{{item.taxesValuePis | numeralFormat('0,0.00')}} </td>
													<td class="tx-right">{{item.taxesValueCofins | numeralFormat('0,0.00')}} </td>
													<td class="tx-right">{{item.taxesValueSiscomex | numeralFormat('0,0.00')}} </td>
												</tr>
											</table>
										</td>
									</tr>
								</tbody>
							</table>
							<br />
						</template>
						<template else>
							<div class="tx-center">Nenhum registro encontrado</div>
						</template>
					</div>
				</div>
			</div>
		</div>
  	</div>
</template>

<script>

import config from '@/config'
import DatePicker from "vue2-datepicker";
import moment from "moment";
import Swal from "sweetalert2";
import Axios from "axios";
import { mask } from "vue-the-mask";

export default {
	name: "DUIMPRegistered",
	props: [],
	components: {
		DatePicker,
	},
	directives: {
		mask,
	},
	data() {
		return { 
			results: {},
			duimps: [],
			listOfCustomers: [],
			filters: {
				start: moment().startOf("month").toDate(),
				end: moment().endOf("month").toDate(),
				customer: null,
			},
		};
	},
	methods: {
		keepOpen(event) {
			event.preventDefault();
			if (event.target && (event.target.tagName === 'A' || event.target.tagName === 'UL')) {
				const dropdowns = document.querySelectorAll('.dropdown-menu');
				dropdowns.forEach((dropdown) => {
					dropdown.classList.remove('show');
				});
			} 
		},
		async generateReport(type) {
			let filters = this.filters;
			this.duimps = [];

			if (filters.start === "" || filters.end === "") {
				Swal.fire(
					"DUIMP Registradas",
					"Você precisa selecionar um período para conseguir gerar o relatório.",
					"error"
				);
				return;
			}
		
			this.$store.commit("setLoading", {
				show: true,
				label: "DUIMP Registradas",
				description: "Aguarde enquanto o relatório está sendo gerado...",
			});

			try {

				let data = {
					start: moment(filters.start).format("YYYY-MM-DD"),
					end: moment(filters.end).format("YYYY-MM-DD"),
					customerId: filters?.customer?.id || "", 
				};
	
				let message = "Relatório gerado com sucesso!";

				if (type === 'excel') {
					const response = await Axios.get(`${config.env.API_DEFAULT.host}/duimp/excel-report?customerId=${data.customerId}&startRegistryDate=${data.start}&endRegistryDate=${data.end}`, { responseType: 'blob' });
					const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', `duimp-registradas-${this.$moment(filters.start).format('DD-MM-YYYY')}-a-${this.$moment(filters.end).format('DD-MM-YYYY')}.xlsx`);
					document.body.appendChild(link);
					link.click();
				} else {
					const response = await Axios.get(`${config.env.API_DEFAULT.host}/duimp/report?customerId=${data.customerId}&startRegistryDate=${data.start}&endRegistryDate=${data.end}`);
					this.duimps = response.data.data;
					message = `Foram encontrados ${this.duimps.length} registros de acordo com o filtro.`;
				}

				Swal.fire(
					"DUIMP Registradas",
					message,
					"success"
				);

				this.$store.commit("setLoading", { show: false });
			} catch (e) {
				console.log(e);
				Swal.fire(
					"DUIMP Registradas",
					"Erro inesperado ao gerar o relatorio.",
					"error"
				);

				this.$store.commit("setLoading", { show: false });
			}
		}
	},
	filters: {
		formatStringToDecimal: (value) => {
			return numeralFormat(value, '0,0.00');
		},
		formatDuimpNumber: (value) => {
			if (value === null || value === undefined) return 'N/I';

			const raw = String(value).toUpperCase();
			const clean = raw.replace(/[^A-Z0-9]/g, '');
			const brIdx = clean.indexOf('BR');
			if (brIdx < 0) {
				return raw;
			}

			const before = clean.slice(0, brIdx).replace(/\D/g, '');
			const after = clean.slice(brIdx + 2).replace(/\D/g, '');

			if (before.length < 2 || after.length < 11) {
				return raw; 
			}

			const part1 = before.slice(0, 2);
			const body = after.slice(0, 10);
			const check = after.slice(10, 11);

			return `${part1}BR${body}-${check}`;
		},
	},
	computed: {
		somaTotalDUIMPs() {
			if ( this.duimps !== null ) {
				return this.duimps.length;
			} else {
				return 0;
			}
		},
	},
	mounted() {
		Axios.get(
			`${config.env.API_DEFAULT.host}/companies/search/findAllByIsCustomerOrderByName?isCustomer=true`
		).then((response) => {
			this.listOfCustomers = response.data._embedded.companies;
		});
	},
};
</script>

<style scoped>

.vs__selected-options span.selected-tag {
  margin: 5px 0px 0px -3px !important;
  padding: 5px !important;
}

.report-slim-pagetitle {
  margin-top: 15px;
  margin-bottom: 10px;
  color: #343a40;

  border-left: 4px solid #4662d4;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 18px;
  line-height: 18px;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #343a40;
  padding: 5px;
}

.report-box {
  max-width: 1100px;
  padding: 5px;
  margin: 20px;
  font-size: 16px;
  line-height: 24px;
  font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
  color: #343a40;
}

.report-box table {
  width: 100%;
}

.report-hr {
  border: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  margin-bottom: 5px;
}

.report-header {
  font-size: 12px;
}

.report-header-left {
  text-align: left;
  border-left: 6px solid #4662d4;
  padding-left: 5px;
}

.report-header-middle {
  padding-left: 20px;
  text-align: left !important;
  line-height: 20px;
}

.report-header-right {
  vertical-align: middle;
  line-height: 10px;
}

.report-header-right small {
  font-size: 10px;
}

.report-list {
  width: 100%;
  border-collapse: collapse;
}

.report-list th {
  text-transform: uppercase;
  font-size: 13px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.8);
}

.report-list td {
  font-size: 11px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.8);
}

.report-footer {
  position: fixed;
  left: 0;
  bottom: 10px;
  width: 100%;
  text-align: center;
  line-height: 8px;
}

.report-footer small {
  font-size: 9px;
}

.report-tx-center {
  text-align: center;
}

.report-tx-bold {
  font-weight: bold;
}

.report-tx-10 {
  font-size: 10px;
}

.columns-list {
  max-height: calc(100vh - 250px);
  overflow: auto;
  border: 1px solid #e2e2e2;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  background-color: white;
}

.columns-list li {
  padding: 0.35rem 0.75rem;
  border-radius: 2px;
  font-weight: 500;
}

.columns-list.active li {
  border-color: #106dc4;
  color: #106dc4;
  background-color: rgba(16, 109, 196, 0.1);
}

.columns-list.active li:hover {
  background-color: #106dc4;
  color: white;
}

.columns-list li:hover {
  cursor: pointer;
}

.columns-list .list-group-item.active {
  border: 1px solid rgba(0, 0, 0, 0.125);
}
</style>
